import { privateRequest } from "../apiConfig/privateRequest";
import { publicRequest } from "../apiConfig/publicRequest";
export const loginUser = (user) => {
    return publicRequest.post('/auth/login', user).then(res => res.data) 
}
export const logoutUser = async () => {
    await privateRequest.get('/auth/logout')
    localStorage.removeItem('authUser');
}